import { configs } from '@hero/configs';

export const endpoints = {
  getTheme: () =>
    configs.cdn.hasInternalAssets
      ? `${configs.publicUrl}/merchants/${configs.merchantName}/theme.json`
      : `${configs.cdn.path}/providers/${configs.env}/dashboard/${configs.merchantName}/theme.json`,
  getConfigs: () =>
    configs.cdn.hasInternalAssets
      ? `${configs.publicUrl}/merchants/${configs.merchantName}/configs.json`
      : `${configs.cdn.path}/providers/${configs.env}/dashboard/${configs.merchantName}/configs.json`,
  getIconSet: () => `${configs.publicUrl}/assets/icons.json`,
  getSelection: () => `${configs.publicUrl}/assets/selection.json`
};
